import React, { useState } from 'react';
import { MessageSquare, Send, Users } from 'lucide-react';

const SendSMSStudents = () => {
  const [formData, setFormData] = useState({
    recipients: 'all',
    course: '',
    message: ''
  });

  const [charCount, setCharCount] = useState(0);
  const maxChars = 160;

  const handleMessageChange = (e) => {
    const text = e.target.value;
    if (text.length <= maxChars) {
      setFormData({ ...formData, message: text });
      setCharCount(text.length);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('SMS data:', formData);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Send SMS to Students</h1>
        <p className="text-sm text-gray-500 mt-1">Send text messages to students</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Form */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Recipients Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Users className="inline h-4 w-4 mr-2" />
                  Select Recipients
                </label>
                <select
                  value={formData.recipients}
                  onChange={(e) => setFormData({ ...formData, recipients: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="all">All Students</option>
                  <option value="course">By Course</option>
                  <option value="semester">By Semester</option>
                  <option value="section">By Section</option>
                  <option value="custom">Custom Selection</option>
                </select>
              </div>

              {/* Conditional Filters */}
              {formData.recipients === 'course' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Select Course</label>
                  <select
                    value={formData.course}
                    onChange={(e) => setFormData({ ...formData, course: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Choose a course</option>
                    <option value="btech">B.Tech</option>
                    <option value="mtech">M.Tech</option>
                    <option value="bba">BBA</option>
                    <option value="mba">MBA</option>
                  </select>
                </div>
              )}

              {/* Message */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <MessageSquare className="inline h-4 w-4 mr-2" />
                  SMS Message
                </label>
                <textarea
                  value={formData.message}
                  onChange={handleMessageChange}
                  placeholder="Type your SMS message here..."
                  rows="6"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
                <div className="flex justify-between mt-2 text-sm">
                  <span className="text-gray-500">Characters: {charCount}/{maxChars}</span>
                  <span className={`font-medium ${
                    charCount > maxChars * 0.9 ? 'text-red-600' : 'text-gray-600'
                  }`}>
                    {Math.ceil(charCount / 160)} SMS
                  </span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4">
                <button
                  type="submit"
                  className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  <Send className="h-4 w-4" />
                  Send SMS
                </button>
                <button
                  type="button"
                  className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Save as Template
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Info Panel */}
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="font-semibold text-blue-900 mb-2">SMS Guidelines</h3>
            <ul className="text-sm text-blue-800 space-y-2">
              <li>• Keep messages short and clear</li>
              <li>• 160 characters = 1 SMS</li>
              <li>• Avoid special characters</li>
              <li>• Include sender identification</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h3 className="font-semibold text-gray-900 mb-2">SMS Statistics</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Total Students:</span>
                <span className="font-semibold">50</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">SMS Sent Today:</span>
                <span className="font-semibold">0</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">SMS Credit:</span>
                <span className="font-semibold text-green-600">500</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendSMSStudents;